import { createFileRoute } from "@tanstack/react-router";
import { GapPharmacyFormPage } from "@/features/contracts/gap-pharmacy-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/apteki-gap/nowy")({
	component: GapPharmacyFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.apteki-gap",
			location.pathname,
		);
	},
});
